import LovStore from "./LovStore";

const lovStore = new LovStore();

export default lovStore;
